







































































import { Component, Prop, Vue } from "vue-property-decorator";
import NavigationItem from "./NavigationItem.vue";

@Component({
  components: { NavigationItem },
})
export default class ExpensionNavigationItem extends Vue {
  @Prop() icon!: string;
  @Prop() label!: string;
  @Prop() mClass!: string;
  @Prop() primaryNotice!: string;
  @Prop() secondaryNotice!: string;
  @Prop() showHideCount!: boolean;
  @Prop() subItems!: {
    icon: string;
    label: string;
    rootPath: string;
    primaryNotice?: string;
    secondaryNotice?: string;
    if: boolean;
    noticeColor?: string;
    noticeColorSecondary?: string;
    // eslint-disable-next-line
    primaryFilter?: (items: any) => any;
    // eslint-disable-next-line
    secondaryFilter?: (items: any) => any;
  }[];
  toggleExpansion = true;

  get primaryNoticeCount() {
    let count = 0;
    if (this.primaryNotice) {
      // eslint-disable-next-line
      // @ts-ignore
      const notice = this.$store.getters[this.primaryNotice];
      count = notice ? notice.count : 0;
    }
    return count;
  }

  get secondaryNoticeCount() {
    let count = 0;
    if (this.secondaryNotice) {
      // eslint-disable-next-line
      // @ts-ignore
      const notice = this.$store.getters[this.secondaryNotice];
      count = notice ? notice.count : 0;
    }
    return count;
  }
}
